import type { OverviewSelectedActionTypesDTO } from 'client'
import type { IReportSettingOption } from '~/constants/types/reportSettings'

export const selectSelectedOption = (
  selectedValue: string,
  options: IReportSettingOption[] | undefined
): IReportSettingOption[] => {
  return (
    options?.map((option) => {
      if (option.value === selectedValue) {
        return { ...option, selected: true }
      }
      return { ...option, selected: false }
    }) ?? []
  )
}

export const getSelectedChoice = (
  settingGroup: IReportSettingOption[] | undefined
): string | undefined => {
  return (
    settingGroup?.find((option) => option.selected === true)?.value ??
    settingGroup?.[0].value
  )
}

export const getSelectedChoices = (
  settingGroup: IReportSettingOption[] | undefined
): string[] => {
  return (
    settingGroup?.reduce((acc: string[], curr) => {
      if (curr.selected) {
        acc.push(curr.value)
      }
      return acc
    }, []) ?? []
  )
}

export const getSelectedActivities = (
  personnelActivities: OverviewSelectedActionTypesDTO[] | undefined
): string[] => {
  return (
    personnelActivities?.reduce((acc: string[], curr) => {
      if (curr.isSelected) {
        acc.push(curr.actionTypeName)
      }
      return acc
    }, []) ?? []
  )
}

export const getEnumValueFromReportSettings = (
  options: IReportSettingOption[],
  enumerable: any
): number | undefined => {
  const enumKey =
    options.find((option) => {
      return option.selected
    })?.value ?? ''

  return enumerable[enumKey]
}

// * this is for the ones that have two options to toggle a single value
export const displayReportToggleToReportSetting = (
  reportSettingOptions: IReportSettingOption[]
): Record<string, boolean> => {
  return {
    [reportSettingOptions[0].value]: reportSettingOptions[0].selected,
  }
}
